import { ytVueGlobalStore } from "@/services/yt-vue-global-store";
const tourSelectorDefault = ytVueGlobalStore.instantGet('tourSelectorDefault');
export default {
  namespaced: true,
  state: {
    defaultOptions: tourSelectorDefault || "",
  },
};
